import React from "react"
import { Grid } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { ExecutionTimeTable, UploadSummaryView, ExtractSummaryView, OverallCountTable, OverallCountSummaryView } from "."

const CaseSummary = () => {
	const [t] = useTranslation("global")

	return (
		<Grid container spacing={2}>
			<Grid item xl={4} lg={4} md={4} xs={12} sm={12}>
				<OverallCountSummaryView />
			</Grid>
			<Grid item xl={8} lg={8} md={8} xs={12} sm={12}>
				<UploadSummaryView />
			</Grid>
			<Grid item xl={4} lg={4} md={4} xs={12} sm={12}>
				<OverallCountTable />
			</Grid>
			<Grid item xl={8} lg={8} md={8} xs={12} sm={12}>
				<ExtractSummaryView />
			</Grid>
			<Grid item xl={4} lg={4} md={4} xs={12} sm={12}>
				<ExecutionTimeTable />
			</Grid>
		</Grid>
	)
}

export default CaseSummary
